

export const current_currency = Cookies.get("currency") || "usd";

export function money(object) {
	return (current_currency == 'clp' ? (object.clp_money) : (object.usd_money))
}

export function from_price(object) {
	return (current_currency == 'clp' ? (object.from_clp_price) : (object.from_usd_price))
}
